module.exports = __webpack_public_path__ + "../resources/img/ic_re_lt_ef_layer_set_3_img.e1f2d7c0.svg";